/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { IAPONCEOFFINVESTMENTSOURCEOFMONEY } from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';
import {
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSONTyped,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON,
} from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { InvestmentDetailsAddUnitTransferViewModel } from './InvestmentDetailsAddUnitTransferViewModel';
import {
    InvestmentDetailsAddUnitTransferViewModelFromJSON,
    InvestmentDetailsAddUnitTransferViewModelFromJSONTyped,
    InvestmentDetailsAddUnitTransferViewModelToJSON,
} from './InvestmentDetailsAddUnitTransferViewModel';
import type { InvestmentDetailsAssetSelectionViewModel } from './InvestmentDetailsAssetSelectionViewModel';
import {
    InvestmentDetailsAssetSelectionViewModelFromJSON,
    InvestmentDetailsAssetSelectionViewModelFromJSONTyped,
    InvestmentDetailsAssetSelectionViewModelToJSON,
} from './InvestmentDetailsAssetSelectionViewModel';
import type { InvestmentDetailsCashTransferViewModel } from './InvestmentDetailsCashTransferViewModel';
import {
    InvestmentDetailsCashTransferViewModelFromJSON,
    InvestmentDetailsCashTransferViewModelFromJSONTyped,
    InvestmentDetailsCashTransferViewModelToJSON,
} from './InvestmentDetailsCashTransferViewModel';
import type { InvestmentDetailsCommissionSplitViewModel } from './InvestmentDetailsCommissionSplitViewModel';
import {
    InvestmentDetailsCommissionSplitViewModelFromJSON,
    InvestmentDetailsCommissionSplitViewModelFromJSONTyped,
    InvestmentDetailsCommissionSplitViewModelToJSON,
} from './InvestmentDetailsCommissionSplitViewModel';
import type { InvestmentDetailsFeeDisinvestmentAssetSplitViewModel } from './InvestmentDetailsFeeDisinvestmentAssetSplitViewModel';
import {
    InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSON,
    InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSONTyped,
    InvestmentDetailsFeeDisinvestmentAssetSplitViewModelToJSON,
} from './InvestmentDetailsFeeDisinvestmentAssetSplitViewModel';
import type { InvestmentDetailsFeesViewModel } from './InvestmentDetailsFeesViewModel';
import {
    InvestmentDetailsFeesViewModelFromJSON,
    InvestmentDetailsFeesViewModelFromJSONTyped,
    InvestmentDetailsFeesViewModelToJSON,
} from './InvestmentDetailsFeesViewModel';
import type { InvestmentDetailsIncomeAssetSplitViewModel } from './InvestmentDetailsIncomeAssetSplitViewModel';
import {
    InvestmentDetailsIncomeAssetSplitViewModelFromJSON,
    InvestmentDetailsIncomeAssetSplitViewModelFromJSONTyped,
    InvestmentDetailsIncomeAssetSplitViewModelToJSON,
} from './InvestmentDetailsIncomeAssetSplitViewModel';
import type { InvestmentDetailsIncomeViewModel } from './InvestmentDetailsIncomeViewModel';
import {
    InvestmentDetailsIncomeViewModelFromJSON,
    InvestmentDetailsIncomeViewModelFromJSONTyped,
    InvestmentDetailsIncomeViewModelToJSON,
} from './InvestmentDetailsIncomeViewModel';
import type { InvestmentDetailsJustPortfolioViewModel } from './InvestmentDetailsJustPortfolioViewModel';
import {
    InvestmentDetailsJustPortfolioViewModelFromJSON,
    InvestmentDetailsJustPortfolioViewModelFromJSONTyped,
    InvestmentDetailsJustPortfolioViewModelToJSON,
} from './InvestmentDetailsJustPortfolioViewModel';
import type { InvestmentDetailsLumpSumViewModel } from './InvestmentDetailsLumpSumViewModel';
import {
    InvestmentDetailsLumpSumViewModelFromJSON,
    InvestmentDetailsLumpSumViewModelFromJSONTyped,
    InvestmentDetailsLumpSumViewModelToJSON,
} from './InvestmentDetailsLumpSumViewModel';
import type { InvestmentDetailsPhaseInViewModel } from './InvestmentDetailsPhaseInViewModel';
import {
    InvestmentDetailsPhaseInViewModelFromJSON,
    InvestmentDetailsPhaseInViewModelFromJSONTyped,
    InvestmentDetailsPhaseInViewModelToJSON,
} from './InvestmentDetailsPhaseInViewModel';
import type { InvestmentDetailsRecurringContributionViewModel } from './InvestmentDetailsRecurringContributionViewModel';
import {
    InvestmentDetailsRecurringContributionViewModelFromJSON,
    InvestmentDetailsRecurringContributionViewModelFromJSONTyped,
    InvestmentDetailsRecurringContributionViewModelToJSON,
} from './InvestmentDetailsRecurringContributionViewModel';
import type { InvestmentDetailsRegularWithdrawalViewModel } from './InvestmentDetailsRegularWithdrawalViewModel';
import {
    InvestmentDetailsRegularWithdrawalViewModelFromJSON,
    InvestmentDetailsRegularWithdrawalViewModelFromJSONTyped,
    InvestmentDetailsRegularWithdrawalViewModelToJSON,
} from './InvestmentDetailsRegularWithdrawalViewModel';
import type { InvestmentDetailsTFSATransferViewModel } from './InvestmentDetailsTFSATransferViewModel';
import {
    InvestmentDetailsTFSATransferViewModelFromJSON,
    InvestmentDetailsTFSATransferViewModelFromJSONTyped,
    InvestmentDetailsTFSATransferViewModelToJSON,
} from './InvestmentDetailsTFSATransferViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsProductViewModel
 */
export interface InvestmentDetailsProductViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsProductViewModel
     */
    productId: number;
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof InvestmentDetailsProductViewModel
     */
    productConfigurationCode: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof InvestmentDetailsProductViewModel
     */
    productCode: IAPPRODUCTCODE;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsProductViewModel
     */
    hasOnceOffInvestment?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsProductViewModel
     */
    productConfigurationId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsProductViewModel
     */
    productCodeId?: number;
    /**
     * 
     * @type {InvestmentDetailsCashTransferViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    cashTransfer?: InvestmentDetailsCashTransferViewModel;
    /**
     * 
     * @type {InvestmentDetailsLumpSumViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    lumpSum?: InvestmentDetailsLumpSumViewModel;
    /**
     * 
     * @type {InvestmentDetailsAddUnitTransferViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    addUnitTransfer?: InvestmentDetailsAddUnitTransferViewModel;
    /**
     * 
     * @type {InvestmentDetailsRecurringContributionViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    recurringContribution?: InvestmentDetailsRecurringContributionViewModel;
    /**
     * 
     * @type {InvestmentDetailsRegularWithdrawalViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    regularWithdrawal?: InvestmentDetailsRegularWithdrawalViewModel;
    /**
     * 
     * @type {InvestmentDetailsFeesViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    fees?: InvestmentDetailsFeesViewModel;
    /**
     * 
     * @type {Array<InvestmentDetailsCommissionSplitViewModel>}
     * @memberof InvestmentDetailsProductViewModel
     */
    commissionSplits?: Array<InvestmentDetailsCommissionSplitViewModel>;
    /**
     * 
     * @type {InvestmentDetailsAssetSelectionViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    fundSelection?: InvestmentDetailsAssetSelectionViewModel;
    /**
     * 
     * @type {InvestmentDetailsPhaseInViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    phaseIn?: InvestmentDetailsPhaseInViewModel;
    /**
     * 
     * @type {Array<InvestmentDetailsFeeDisinvestmentAssetSplitViewModel>}
     * @memberof InvestmentDetailsProductViewModel
     */
    feeDisinvestmentAssetSplit?: Array<InvestmentDetailsFeeDisinvestmentAssetSplitViewModel>;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof InvestmentDetailsProductViewModel
     */
    feeDisinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {IAPONCEOFFINVESTMENTSOURCEOFMONEY}
     * @memberof InvestmentDetailsProductViewModel
     */
    onceOffSourceOfMoney?: IAPONCEOFFINVESTMENTSOURCEOFMONEY;
    /**
     * 
     * @type {InvestmentDetailsIncomeViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    income?: InvestmentDetailsIncomeViewModel;
    /**
     * 
     * @type {Array<InvestmentDetailsIncomeAssetSplitViewModel>}
     * @memberof InvestmentDetailsProductViewModel
     */
    incomeAssetSplit?: Array<InvestmentDetailsIncomeAssetSplitViewModel>;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof InvestmentDetailsProductViewModel
     */
    incomeSourceTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {InvestmentDetailsTFSATransferViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    tFSATransfer?: InvestmentDetailsTFSATransferViewModel;
    /**
     * 
     * @type {InvestmentDetailsJustPortfolioViewModel}
     * @memberof InvestmentDetailsProductViewModel
     */
    justPortfolio?: InvestmentDetailsJustPortfolioViewModel;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsProductViewModel
     */
    canWriteJustBusiness?: IAPYESORNO;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsProductViewModel
     */
    hasJustPortfolio?: IAPYESORNO;
}

/**
 * Check if a given object implements the InvestmentDetailsProductViewModel interface.
 */
export function instanceOfInvestmentDetailsProductViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productConfigurationCode" in value;
    isInstance = isInstance && "productCode" in value;

    return isInstance;
}

export function InvestmentDetailsProductViewModelFromJSON(json: any): InvestmentDetailsProductViewModel {
    return InvestmentDetailsProductViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsProductViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsProductViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['ProductId'],
        'productConfigurationCode': IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'productCode': IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'hasOnceOffInvestment': !exists(json, 'HasOnceOffInvestment') ? undefined : IAPYESORNOFromJSON(json['HasOnceOffInvestment']),
        'productConfigurationId': !exists(json, 'ProductConfigurationId') ? undefined : json['ProductConfigurationId'],
        'productCodeId': !exists(json, 'ProductCodeId') ? undefined : json['ProductCodeId'],
        'cashTransfer': !exists(json, 'CashTransfer') ? undefined : InvestmentDetailsCashTransferViewModelFromJSON(json['CashTransfer']),
        'lumpSum': !exists(json, 'LumpSum') ? undefined : InvestmentDetailsLumpSumViewModelFromJSON(json['LumpSum']),
        'addUnitTransfer': !exists(json, 'AddUnitTransfer') ? undefined : InvestmentDetailsAddUnitTransferViewModelFromJSON(json['AddUnitTransfer']),
        'recurringContribution': !exists(json, 'RecurringContribution') ? undefined : InvestmentDetailsRecurringContributionViewModelFromJSON(json['RecurringContribution']),
        'regularWithdrawal': !exists(json, 'RegularWithdrawal') ? undefined : InvestmentDetailsRegularWithdrawalViewModelFromJSON(json['RegularWithdrawal']),
        'fees': !exists(json, 'Fees') ? undefined : InvestmentDetailsFeesViewModelFromJSON(json['Fees']),
        'commissionSplits': !exists(json, 'CommissionSplits') ? undefined : ((json['CommissionSplits'] as Array<any>).map(InvestmentDetailsCommissionSplitViewModelFromJSON)),
        'fundSelection': !exists(json, 'FundSelection') ? undefined : InvestmentDetailsAssetSelectionViewModelFromJSON(json['FundSelection']),
        'phaseIn': !exists(json, 'PhaseIn') ? undefined : InvestmentDetailsPhaseInViewModelFromJSON(json['PhaseIn']),
        'feeDisinvestmentAssetSplit': !exists(json, 'FeeDisinvestmentAssetSplit') ? undefined : ((json['FeeDisinvestmentAssetSplit'] as Array<any>).map(InvestmentDetailsFeeDisinvestmentAssetSplitViewModelFromJSON)),
        'feeDisinvestmentTypeId': !exists(json, 'FeeDisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['FeeDisinvestmentTypeId']),
        'onceOffSourceOfMoney': !exists(json, 'OnceOffSourceOfMoney') ? undefined : IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON(json['OnceOffSourceOfMoney']),
        'income': !exists(json, 'Income') ? undefined : InvestmentDetailsIncomeViewModelFromJSON(json['Income']),
        'incomeAssetSplit': !exists(json, 'IncomeAssetSplit') ? undefined : ((json['IncomeAssetSplit'] as Array<any>).map(InvestmentDetailsIncomeAssetSplitViewModelFromJSON)),
        'incomeSourceTypeId': !exists(json, 'IncomeSourceTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['IncomeSourceTypeId']),
        'tFSATransfer': !exists(json, 'TFSATransfer') ? undefined : InvestmentDetailsTFSATransferViewModelFromJSON(json['TFSATransfer']),
        'justPortfolio': !exists(json, 'JustPortfolio') ? undefined : InvestmentDetailsJustPortfolioViewModelFromJSON(json['JustPortfolio']),
        'canWriteJustBusiness': !exists(json, 'CanWriteJustBusiness') ? undefined : IAPYESORNOFromJSON(json['CanWriteJustBusiness']),
        'hasJustPortfolio': !exists(json, 'HasJustPortfolio') ? undefined : IAPYESORNOFromJSON(json['HasJustPortfolio']),
    };
}

export function InvestmentDetailsProductViewModelToJSON(value?: InvestmentDetailsProductViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductId': value.productId,
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'HasOnceOffInvestment': IAPYESORNOToJSON(value.hasOnceOffInvestment),
        'ProductConfigurationId': value.productConfigurationId,
        'ProductCodeId': value.productCodeId,
        'CashTransfer': InvestmentDetailsCashTransferViewModelToJSON(value.cashTransfer),
        'LumpSum': InvestmentDetailsLumpSumViewModelToJSON(value.lumpSum),
        'AddUnitTransfer': InvestmentDetailsAddUnitTransferViewModelToJSON(value.addUnitTransfer),
        'RecurringContribution': InvestmentDetailsRecurringContributionViewModelToJSON(value.recurringContribution),
        'RegularWithdrawal': InvestmentDetailsRegularWithdrawalViewModelToJSON(value.regularWithdrawal),
        'Fees': InvestmentDetailsFeesViewModelToJSON(value.fees),
        'CommissionSplits': value.commissionSplits === undefined ? undefined : ((value.commissionSplits as Array<any>).map(InvestmentDetailsCommissionSplitViewModelToJSON)),
        'FundSelection': InvestmentDetailsAssetSelectionViewModelToJSON(value.fundSelection),
        'PhaseIn': InvestmentDetailsPhaseInViewModelToJSON(value.phaseIn),
        'FeeDisinvestmentAssetSplit': value.feeDisinvestmentAssetSplit === undefined ? undefined : ((value.feeDisinvestmentAssetSplit as Array<any>).map(InvestmentDetailsFeeDisinvestmentAssetSplitViewModelToJSON)),
        'FeeDisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.feeDisinvestmentTypeId),
        'OnceOffSourceOfMoney': IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON(value.onceOffSourceOfMoney),
        'Income': InvestmentDetailsIncomeViewModelToJSON(value.income),
        'IncomeAssetSplit': value.incomeAssetSplit === undefined ? undefined : ((value.incomeAssetSplit as Array<any>).map(InvestmentDetailsIncomeAssetSplitViewModelToJSON)),
        'IncomeSourceTypeId': IAPDISINVESTMENTTYPEToJSON(value.incomeSourceTypeId),
        'TFSATransfer': InvestmentDetailsTFSATransferViewModelToJSON(value.tFSATransfer),
        'JustPortfolio': InvestmentDetailsJustPortfolioViewModelToJSON(value.justPortfolio),
        'CanWriteJustBusiness': IAPYESORNOToJSON(value.canWriteJustBusiness),
        'HasJustPortfolio': IAPYESORNOToJSON(value.hasJustPortfolio),
    };
}

